<template>
	<div class="row">
		<!-- TODO - Always have user access permissions for current auth user on current account.
			Ensure current user is non-admin/super here -->
		<div v-if="user.id === currentAccount.account_owner_id" class="cell"><span class="tag brand-bg">Account Admin</span></div>
		<div v-else-if="status === STATUS.ACTIVE && user.id !== currentUser.id" class="cell buttons">
			<router-link v-if="!isSuper" :to="`/account/users/${ user.id }/edit`" class="button"><div class="hover-title">Update</div><span class="fa fa-pencil"></span></router-link>
			<action-button text="Deactivate" button-class="button" icon="fa-ban" :requires-confirmation="true" @execute="deactivate"></action-button>
		</div>
		<div v-else-if="status === STATUS.INVITED" class="cell buttons">
			<router-link v-if="!isSuper" :to="`/account/users/${ user.id }/edit`" class="button"><div class="hover-title">Update</div><span class="fa fa-pencil"></span></router-link>
			<action-button text="Resend Invitation" button-class="button" icon="fa-paper-plane" @execute="resend"></action-button>
			<action-button text="Withdraw Invitation" button-class="button" icon="fa-ban" :requires-confirmation="true" @execute="cancel"></action-button>
		</div>
		<div v-else-if="status === STATUS.DECLINED" class="cell buttons"><span class="tag bad-bg">Declined Invitation</span></div>
		<div v-else-if="status === STATUS.REVOKED" class="cell buttons">
			<router-link v-if="!isSuper" :to="`/account/users/${ user.id }/edit`" class="button"><div class="hover-title">Update</div><span class="fa fa-pencil"></span></router-link>
			<action-button text="Reactivate" button-class="button" icon="fa-thumbs-up" :requires-confirmation="true" @execute="reinstate"></action-button>
		</div>
		<div v-else-if="user.id === currentUser.id" class="cell"><span class="tag brand-bg">Cannot Edit Yourself</span></div>
		<div v-else class="cell align-right"></div>
		<div class="cell">{{ user.name || user.email }}</div>
		<div class="cell">
			<b>{{ friendlyAccessLevel | capitalize }}</b>
			<ul v-if="!isSuper">
				{{ /* checks !hasAdminAcces as we don't need to be explicit about admins here. They have it all */ }}
				<li v-if="!hasAdminAccess && canManageUsers">Can Manage Users</li>
				<li v-for="module in permissions" :key="`access-${ module }`">{{ moduleName(module) }}</li>
				<li v-if="user.access.access_type === 'BASIC' && permissions.length === 0" ><i>No Access</i></li>
			</ul>
		</div>
		<div class="cell">
			<div class="tag">{{ status.toLowerCase() | capitalize }}</div>
		</div>
	</div>
</template>

<script>

import _ from 'underscore';
import { mapGetters } from 'vuex';
import { ACCESS_TYPE } from '@/constants/connections';

export default {

	props: {
		user: {
			required: true,
		}
	},

	data() {
		return {
			STATUS: {
				ACTIVE: 'ACTIVE',
				INVITED: 'INVITED',
				DECLINED: 'DECLINED',
				REVOKED: 'REVOKED',
				CANCELLED: 'CANCELLED',
			}
		};
	},

	computed: {

		...mapGetters([ 'currentAccount', 'currentUser', 'modules' ]),

		isSuper() {
			return this.user.access_level === 'Super';
		},

		status() {
			return this.user.access.status;
		},

		canManageUsers() {
			return this.hasAdminAccess;
		},

		permissions() {
			return this.user.access.access_type !== ACCESS_TYPE.BASIC ? [] : (this.user.access.access_permissions || '').split(',').filter(value => !!value);
		},

		hasAdminAccess() {
			return this.user.access.access_type === ACCESS_TYPE.ADMIN;
		},

		friendlyAccessLevel() {
			if (this.isSuper) {
				return 'Super Admin';
			}

			switch (this.user.access.access_type) {
				case ACCESS_TYPE.ADMIN:
					return 'Administrator';
				case ACCESS_TYPE.BASIC:
					return 'Partial Access';
				default:
					return this.user.access.access_type + ' Access';
			}
		}

	},

	methods: {

		async deactivate(done) {
			await this.$api.post(`/account/connections/${ this.user.id }/revoke`);

			this.user.access.status = this.STATUS.REVOKED;
			this.$emit('changed', this.user);
			this.$store.dispatch('addToast', { message: 'User Deactivated', type: 'brand-bg' });

			done();

		},

		async cancel(done) {
			await this.$api.delete(`/account/connections/${ this.user.id }/cancel`);

			this.user.access.status = this.STATUS.CANCELLED;
			this.$emit('changed', this.user);
			this.$store.dispatch('addToast', 'Invitation Rescinded');

			done();

		},

		async reinstate(done) {
			await this.$api.post(`/account/connections/${ this.user.id }/reinstate`);

			this.user.access.status = this.STATUS.ACTIVE;
			this.$emit('changed', this.user);
			this.$store.dispatch('addToast', 'User Access Reinstated');

			done();

		},

		async resend(done) {
			try {
				await this.$api.post(`/account/connections/${this.user.id}/resend-invite`);

				this.$emit('changed', this.user);
				this.$store.dispatch('addToast', 'Invitation Re-sent');
			} catch (e) {
				this.$store.dispatch('errorToast', this.$api.getErrorMessage(e));

			}

			done();

		},

		moduleName(slug) {
			if (slug === 'inquiries') return 'Web Inquiries';
			return (_.findWhere(this.modules, { slug }) || {}).name || slug;
		}
	}

};

</script>
